<script>
    import InfiniteTree from 'infinite-tree';
    import {nextTick} from "vue";
    import {Listeners} from "../../../../../constants/listeners";
    import InputText from "primevue/inputtext";

    export default {
        data() {
            return {
                infiniteTree: null,
                filter: null
            }
        },
        emits: ['update:pid'],
        props: ['tree', 'pid', 'focus', 'nodeDisabled'],
        methods: {
            doFilter(){

                let self = this;

                if(!this.filter){
                    this.infiniteTree.unfilter();
                    return false;
                }

                let search = self.filter.split("+");

                const filterOptions = {
                    exactMatch: false
                };

                this.infiniteTree.filter((node) => {
                    const name = node.name || '';

                    let result = false;

                    if(node.id <= 0){
                        return false;
                    }

                    if(node.state.selected){
                        return true;
                    }

                    if(self.filter){

                        if(search.length > 1){

                            result = search.every((q) => {
                                return name.toLowerCase().indexOf(q.toLowerCase().trim()) >= 0;
                            });

                        }else{
                            result = name.toLowerCase().indexOf(self.filter.toLowerCase().trim()) >= 0;
                        }

                    }

                    return result;

                }, filterOptions);

            },
            highlight(value){
                if(!this.filter){
                    return value;
                }

                let pattern = "(" + this.filter.split("+").map((item) => {return item.trim()}).join("|") + ")",

                    result = this.filter.split("+").every((q) => {
                        return value.toLowerCase().indexOf(q.toLowerCase().trim()) >= 0;
                    });

                if(!result){
                    return value;
                }

                return value.replace(new RegExp(pattern, 'gi'), '<span style="background-color: #338fff; color: #fff">' + '$&' + '</span>');
            },

        },

        beforeDestroy(){
            if(this.infiniteTree){
                this.infiniteTree.destroy();
            }
        },

        mounted() {

            let self = this;

            let nodes = this.tree.cloneNode(this.tree.getNodeById(0));

            if (this.focus) {
                let self = this;
                nextTick(() => {
                    self.$refs.input.$el.focus();
                });
            }

            const tree = new InfiniteTree({
                el: document.querySelector('.infinite-tree-container'),
                data: JSON.parse(nodes),
                autoOpen: true,
                nodeIdAttr: 'data-id',
                rowRenderer: function (node, treeOptions) {
                    const {id, name, state} = node;
                    const {depth, filtered, checked, selected = false} = state;

                    if (filtered === false) {
                        return;
                    }

                    let classes = ['infinite-tree-item'];
                    if (selected) {
                        classes.push('infinite-tree-selected');
                    }

                    return '<div data-id="' + id + '" class="' + classes.join(' ') + '" style="' + `margin-left: ${depth * 12}px` + '">' + self.highlight(name) + '</div>';
                },
                shouldSelectNode: (node) => {
                    if (!node || (node === tree.getSelectedNode())) {
                        return false;
                    }
                    if (self.nodeDisabled.indexOf(node.id) !== -1) {
                        return false;
                    }
                    return true;
                }
            });

            tree.on('click', (event) => {
                const currentNode = tree.getNodeFromPoint(event.clientX, event.clientY);
                if (!currentNode) {
                    return;
                }
                tree.selectNode(currentNode);
            });

            tree.on('selectNode', (node) => {
                self.$emit('update:pid', node.id);
                self.$emitter.emit(Listeners.CLUSTER_KEYS_MOVE_FOLDER, node.id);

            });

            /*if(!this.value){
                this.$emit('input', 0);
            }*/

            let selectNode = tree.getNodeById(this.pid);
            tree.selectNode(selectNode);
            tree.scrollToNode(selectNode);

            this.infiniteTree = tree;
            this.infiniteTree.unfilter();
        },

        watch: {
            filter(newVal, oldVal) {
                if(!newVal) {
                    this.doFilter();
                }
            }
        },
        components: {
            InputText,
        },
    }
</script>
<template>
    <div>
        <InputText v-model="filter" :placeholder="$t('lang.cluster.it_search_placeholder')" @keyup.enter="doFilter" ref="input" />
        <div class="infinite-tree-container"></div>
    </div>

</template>

<style>

    .infinite-tree-scroll-search{
        width: 100%;
        /*border-bottom: 1px solid transparent!important;*/
    }

    .infinite-tree-scroll {
        overflow: auto;
        height: 250px;
    }

    .infinite-tree-content {
        outline: 0;
        position: relative;
        border: solid 1px #dee0e2;;
        background-color: #fff;
        font-size: 13px;
    }

    .infinite-tree-content .infinite-tree-selected.infinite-tree-item,
    .infinite-tree-content .infinite-tree-selected.infinite-tree-item:hover {
        background: #deecfd;
        border: 1px solid #06c;
    }

    .infinite-tree-content .infinite-tree-item {
        border: 1px solid transparent;
        cursor: default;
        line-height: 20px;
    }

    .infinite-tree-content .infinite-tree-item:hover {
        background: #f2fdff;
    }

    .infinite-tree-content .infinite-tree-item:disabled,
    .infinite-tree-content .infinite-tree-item[disabled] {
        cursor: not-allowed;
        opacity: 0.5;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
        filter: alpha(opacity=50);
    }

    .infinite-tree-content .infinite-tree-node {
        position: relative;
    }

    .infinite-tree-content .infinite-tree-toggler {
        color: #666;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .infinite-tree-content .infinite-tree-toggler:hover {
        color: #333;
        text-decoration: none;
    }

    .infinite-tree-content .infinite-tree-title {
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .infinite-tree-no-data {
        text-align: center;
    }

    .infinite-tree-content i {
         margin-left: 2px;
     }

</style>
